import { createFileRoute, notFound } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import { parseYearSlug } from "@/lib/calendar/dates";
import { TanggalMerahPage as TanggalMerahPageView } from "@/components/pages/TanggalMerahPage";
import { getHolidaysForYear } from "@/data/holidays";
import { itemListSchema, breadcrumbSchema, ldScripts } from "@/lib/seo/schema";

export const Route = createFileRoute("/tanggal-merah/$year")({
  loader: ({ params }) => {
    const y = parseYearSlug(params.year);
    if (!y) throw notFound();
    return { y };
  },
  head: ({ loaderData }) => {
    const y = loaderData?.y ?? "";
    const events = typeof y === "number"
      ? getHolidaysForYear(y).map((h) => ({
          name: h.name, date: h.date,
          description: h.type === "libur" ? `Libur nasional ${y}.` : `Cuti bersama ${y}.`,
          url: `/tanggal-merah/${y}`,
        }))
      : [];
    return {
      meta: [
        { title: `Tanggal Merah ${y} Indonesia - Daftar Lengkap Libur & Cuti Bersama` },
        { name: "description", content: `Daftar lengkap tanggal merah ${y} di Indonesia: semua libur nasional, cuti bersama, libur lebaran, Idul Fitri, Idul Adha, Natal, Imlek, Nyepi, plus hari Minggu sepanjang tahun.` },
        { name: "keywords", content: `tanggal merah ${y}, libur ${y}, libur nasional ${y}, cuti bersama ${y}, libur lebaran ${y}, kalender merah ${y}` },
        { property: "og:title", content: `Tanggal Merah ${y}` },
        { property: "og:description", content: `Semua tanggal merah Indonesia ${y}: libur nasional, cuti bersama, dan hari Minggu.` },
      ],
      scripts: typeof y === "number" ? ldScripts([
        breadcrumbSchema([
          { name: "Beranda", url: "/" },
          { name: `${y}`, url: `/${y}` },
          { name: `Tanggal Merah ${y}`, url: `/tanggal-merah/${y}` },
        ]),
        events.length > 0 ? itemListSchema(events, "id") : null,
      ].filter(Boolean) as unknown[]) : [],
    };
  },
  component: TanggalMerahPageRoute,
  notFoundComponent: () => (
    <SiteShell>
      <div className="py-16 text-center"><h1 className="text-2xl font-bold">Tahun tidak valid</h1></div>
    </SiteShell>
  ),
});

function TanggalMerahPageRoute() {
  const { y } = Route.useLoaderData();
  return <TanggalMerahPageView y={y} />;
}